/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  TCheckPaymentModel,
  ICheckPaymentRequest,
  IMappers,
  ICheckPaymentResponse,
  ICheckPaymentResponseError,
  TCheckPaymentResponse
} from "./types";

const defaultConfig: TCheckPaymentModel = {
  apiType: "public",
  assertStatusCodes: [200, 400],
  method: "GET",
  microserviceName: "billing-payments",
  pathApi: "/v3/check-payment/",
  hostType: "api"
} as TCheckPaymentModel;

function createCheckPaymentModel(
  parameters: ICheckPaymentRequest
): TCheckPaymentModel {
  return {
    ...defaultConfig,
    parameters
  };
}

export interface ICheckPaymentOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICheckPaymentRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCheckPayment<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers
}: ICheckPaymentOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCheckPaymentResponse
> {
  const { response, statusCode } = await httpApi.fetch(
    createCheckPaymentModel(parameters),
    config
  );

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICheckPaymentResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICheckPaymentResponseError);
    }
  }

  return { response, statusCode } as TCheckPaymentResponse;
}

export { defaultConfig, createCheckPaymentModel, fetchCheckPayment };
